

































































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import Dashboard from "@/components/case/Dashboard.vue";
import Tasks from "@/components/case/Tasks.vue";
import TaskCalendar from "@/components/case/TaskCalendar.vue";
import CaseEditor from "@/components/case/edit/CaseEditor.vue";
import { randomId } from "@/utils";
import { Tab, Tabs } from "@/store/modules/types";
import PatientEditor from "@/components/patient/PatientEditor.vue";
import FormViewer from "@/components/FormViewer.vue";
import CaseForm from "@/components/case/Form.vue";
import CasePDF from "@/components/case/CasePDF.vue";

@Component({
  components: {
    Header,
    EntityTabs,
    Dashboard,
    Tasks,
    TaskCalendar,
    CaseEditor,
    PatientEditor,
    FormViewer,
    CaseForm,
    CasePDF,
  },
  computed: {
    ...mapState("cases", ["tabs"]),
  },
})
export default class Cases extends Vue {
  tabs!: Tabs;
  patientId: number | null = null;
  setActiveTab(tab) {
    this.$store.commit("cases/SET_ACTIVE_TAB", tab);
  }
  addNewCaseTab() {
    const id = randomId(6);
    const tab: Tab = {
      id,
      name: "New Case",
      component: "CaseEditor",
      props: {
        tabId: id,
      },
      showRemove: true,
    };
    this.$store.commit("cases/ADD_NEW_TAB", tab);
  }
  removeTab(id: string) {
    this.$store.commit("cases/REMOVE_TAB", id);
  }
  editPatient(id: number) {
    this.patientId = id;
    this.$modal.show("patient-editor");
  }
}
